/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { ClusterInstanceInfo } from '@modules/cloud-api/v1/types'
import type { StackDeployment, NodeStats } from '@modules/ui-types'

import { getNodeStatsForInstance } from '@/reducers/nodeStats'

import FrozenNodeUsage from './FrozenNodeUsage'

type StateProps = {
  nodeStats: NodeStats | undefined
}
interface DispatchProps {}

type ConsumerProps = {
  deployment: StackDeployment
  instance: ClusterInstanceInfo
}

const mapStateToProps = (state: any, { deployment, instance }: ConsumerProps): StateProps => {
  const { id } = deployment

  return {
    nodeStats: getNodeStatsForInstance(state, id, instance.instance_name),
  }
}

const mapDispatchToProps = (): DispatchProps => ({})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(FrozenNodeUsage)
